import { useId, useState } from "react";
import { EyeIcon, EyeOffIcon } from "../icons/EyeIcons";
import "./Input.css";

export default function Input({
  label,
  error,
  helper,
  leftIcon,
  rightIcon,
  secure = false,
  id,
  type,
  className,
  disabled,
  ...rest
}) {
  const generatedId = useId();
  const inputId = id || `vs-input-${generatedId}`;
  const helperId = `${inputId}-helper`;
  const errorId = `${inputId}-error`;
  const [revealed, setRevealed] = useState(false);

  const effectiveType = secure ? (revealed ? "text" : "password") : type || "text";

  const wrapperCls = [
    "vs-input",
    error && "vs-input--error",
    disabled && "vs-input--disabled",
    leftIcon && "vs-input--has-left",
    (rightIcon || secure) && "vs-input--has-right",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="vs-input-field">
      {label && (
        <label className="vs-input__label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <div className={wrapperCls}>
        {leftIcon && (
          <span className="vs-input__icon vs-input__icon--left" aria-hidden="true">
            {leftIcon}
          </span>
        )}
        <input
          id={inputId}
          type={effectiveType}
          className="vs-input__control"
          disabled={disabled}
          aria-invalid={!!error || undefined}
          aria-describedby={
            [error && errorId, helper && !error && helperId]
              .filter(Boolean)
              .join(" ") || undefined
          }
          {...rest}
        />
        {secure ? (
          <button
            type="button"
            className="vs-input__icon vs-input__icon--right vs-input__reveal"
            onClick={() => setRevealed((r) => !r)}
            aria-label={revealed ? "Hide password" : "Show password"}
            tabIndex={0}
          >
            {revealed ? <EyeOffIcon size={18} /> : <EyeIcon size={18} />}
          </button>
        ) : (
          rightIcon && (
            <span className="vs-input__icon vs-input__icon--right" aria-hidden="true">
              {rightIcon}
            </span>
          )
        )}
      </div>
      {error ? (
        <p id={errorId} className="vs-input__error">
          {error}
        </p>
      ) : helper ? (
        <p id={helperId} className="vs-input__helper">
          {helper}
        </p>
      ) : null}
    </div>
  );
}
